export default "__VITE_ASSET__DTOiadAn__"